import React from 'react';
import { ConfirmEditButtons, StyledTextField } from '@retail/my-assortment/components';
import { Box } from '@mui/material';
import { UseControllerReturn } from 'react-hook-form';

interface Props {
  onSubmit: () => void;
  onCancel: () => void;
  controller: UseControllerReturn<any, any>;
  initValue?: number;
}

export const EditPriceCell: React.FC<Props> = ({ onSubmit, onCancel, controller, initValue }) => {
  return (
    <Box display="flex">
      <StyledTextField
        {...controller.field}
        value={controller.field.value ?? initValue}
        size="small"
        error={!!controller.fieldState.error?.message}
        helperText={controller.fieldState.error?.message}
        onKeyDown={(e) => {
          if (e.key === 'Enter') onSubmit();
        }}
      />

      <ConfirmEditButtons onSubmit={onSubmit} onCancel={onCancel} />
    </Box>
  );
};
